<template>
    <div :class="$style.wrapper">
        <iframe
            id="charge"
            width="100%"
            style="border: 0"
            :srcdoc="content"
            onload="iFrameHeight('charge')"
        ></iframe>
    </div>
</template>

<script>
    import { getChargeStandard } from '../stores/api';

    export default {
        data () {
            return {
                content: '',
            };
        },
        beforeMount () {
            getChargeStandard().then(res => {
//            this.content = new DOMParser().parseFromString(res.data.content, 'text/xml');
                this.content = res.data;
            });
        },
        methods: {
//            iFrameHeight (id) {
//                const ifm = document.getElementById(id);
//                if (ifm) {
//                    const height = ifm.contentDocument.body.offsetHeight;
//                    ifm.height = height + 80;
//                }
//            },
        }
    };
</script>

<style lang="less" module>
    .wrapper {

    }
</style>



// WEBPACK FOOTER //
// src/router/Charge.vue